import type { NextPageWithLayout } from "@interfaces/PageInterfaces";
import { customerServiceLegalPages } from "@lib/constants/pagePaths";
import { PageTypes } from "@lib/enums/PageTypes";
import { getDefaultLayout, getDefaultLayoutWithGrayBody } from "@lib/utils/layoutUtility";
import type { GetStaticPaths, GetStaticPropsContext, PreviewData } from "next";
import type { ParsedUrlQuery } from "querystring";
import type { GenericPageProps } from "templates/GenericPage";
import { GenericPage, generateGetStaticPropsForGenericPage } from "templates/GenericPage";
import type { TwoColumnsPageProps } from "templates/TwoColumnPage";
import { TwoColumnsPage } from "templates/TwoColumnPage";

interface CustomerServiceLegalPageProps extends GenericPageProps, TwoColumnsPageProps {
    serializedPage: any;
}

const CustomerServiceLegalPage: NextPageWithLayout<CustomerServiceLegalPageProps> = (props) => {
    const LayoutComponent = () => {
        if (props.pageType === PageTypes.GENERIC) {
            return <GenericPage {...props} />;
        }
        if (props.pageType === PageTypes.CUSTOMER_SERVICE) {
            return <TwoColumnsPage {...props} />;
        }
    };

    return (
        <>
            <div hidden aria-hidden="true" data-testid="legalPagesSlug" />
            <LayoutComponent />
        </>
    );
};

CustomerServiceLegalPage.getLayout = (props) => {
    const { page } = props;
    const { pageType } = page.props;
    return pageType === PageTypes.CUSTOMER_SERVICE
        ? getDefaultLayoutWithGrayBody({
              ...props,
              pageProps: { ...props.pageProps, chatButtonPersist: true },
          })
        : getDefaultLayout({
              ...props,
              pageProps: { ...props.pageProps, chatButtonPersist: true },
          });
};

export default CustomerServiceLegalPage;

export const getStaticProps = async (
    context: GetStaticPropsContext<ParsedUrlQuery, PreviewData>
) => {
    return await generateGetStaticPropsForGenericPage(context, customerServiceLegalPages);
};

export const getStaticPaths: GetStaticPaths = async () => {
    return {
        paths: [],
        fallback: "blocking",
    };
};
